<template>
    <div :class="$style.footer">
        <NonCriticalCSSInject />
        <template v-if="props.game">
            <DesktopFooterPortalContent
                v-if="portalButtons"
                ref="desktop-footer-content"
                :game="props.game"
                :instreamData="props.instreamData"
                :category="props.category"
                :isNoAdButtonShown="props.isNoAdButtonShown"
                :isFullscreen="props.isFullscreen"
                :shareData="props.shareData"
                :limitedAvailability="props.limitedAvailability"
                :isFullscreenButtonHidden="props.isFullscreenButtonHidden"
                :disabledIcon="props.disabledIcon"
                @toggleFullscreen="emit('toggleFullscreen')"
                @openDisabledAdModal="emit('openDisabledAdModal')"
            />
            <DesktopFooterMinimalContent
                v-else
                :isFullscreen="props.isFullscreen"
                @toggleFullscreen="emit('toggleFullscreen')"
                @closeGame="emit('closeGame')"
            />
        </template>
    </div>
</template>

<script lang="ts" setup>
import { useTemplateRef } from 'vue'

import NonCriticalCSSInject from '@/components_new/NonCriticalCSSInject.vue'
import type { APIGameType, InstreamData } from '@/types'

import DesktopFooterMinimalContent from './DesktopFooterMinimalContent.vue'
import DesktopFooterPortalContent from './DesktopFooterPortalContent.vue'

const props = defineProps<{
    game: APIGameType | undefined
    instreamData: InstreamData
    category: string | undefined
    isNoAdButtonShown: boolean
    isFullscreen: boolean
    shareData: ShareData
    limitedAvailability: boolean
    portalButtons?: boolean
    isFullscreenButtonHidden?: boolean
    disabledIcon?: boolean
}>()

const emit = defineEmits<{
    toggleFullscreen: []
    openDisabledAdModal: []
    closeGame: []
}>()

const desktopFooterContent = useTemplateRef('desktop-footer-content')

defineExpose({
    showLoginTooltip: () => desktopFooterContent.value?.showLoginTooltip(),
})
</script>

<style module>
.footer {
    padding: 4px;
    height: 56px;
    box-sizing: border-box;
    display: none;
    gap: 4px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border-radius: 0 0 var(--container-border-radius) var(--container-border-radius);
}

@media (--tablet-plus) {
    .footer {
        display: flex;
    }
}
</style>
